import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export default function IngestReportItem({type, text}:any) {
    return (
        <Box className="ingest-report__info-summary-item">
            <Typography
                variant="h5"
                className="ingest-report__info-summary-item-inner"
            >
                {text}
            </Typography>
            <Typography
                variant="h5"
            >
                {type}
            </Typography>
        </Box>
    );
}
